import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { ExamOperationService } from 'src/app/exam-layout/operations/exam-operation.service';
import { IComplaintCategory, IComplaintCategoryMapping } from 'src/app/interface/dto';
import { ComplaintService } from 'src/app/services/complaint-services.service';
import { EventService } from 'src/app/services/event-services/error-event.service';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { AddComplaintCategoryComponent } from '../add-complaint-category/add-complaint-category.component';
import { AddComplaintCategoryMappingComponent } from '../add-complaint-category-mapping/add-complaint-category-mapping.component';

@Component({
  selector: 'app-complaint-category-mapping',
  templateUrl: './complaint-category-mapping.component.html',
  styleUrls: ['./complaint-category-mapping.component.scss']
})
export class ComplaintCategoryMappingComponent implements OnInit {


  categories: IComplaintCategoryMapping[] = null;
  selectedCategories: IComplaintCategoryMapping = {
    categoryID: '',
    examStatus: '',
    id: 0
  };

  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject<any>();
  constructor(private complaintService: ComplaintService, private snackBar: SnackbarService,
    private examOps: ExamOperationService, private evnt: EventService) { }

  async ngOnInit() {
    await this.refreshCategory();
    this.evnt.adCategoryMapMessageEvent.subscribe(async (message: any) => {
      await this.refreshCategory();
    });
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
    this.evnt.adCategoryMapMessageEvent.unsubscribe();
  }
  addCategory(origin) {
    sessionStorage.setItem("selectedComplaintCategoryMap", null);
    this.examOps.openModal(origin, AddComplaintCategoryMappingComponent)
  }

  editCategory(origin, category) {
    sessionStorage.setItem("selectedComplaintCategoryMap", JSON.stringify(category));
    this.examOps.openModal(origin, AddComplaintCategoryMappingComponent);
  }

  async refreshCategory() {
    await this.complaintService.getComplaintCategoryMap().then((c: any) => {
      this.categories = c;
    });
  }

  deleteCategory(cat: any) {
    console.log(cat, 'cat');
    
    this.complaintService.deleteComplaintCategoryMap(cat).then((response: any) => {
      this.snackBar.success('Category deleted');
      this.categories = this.categories.filter(c => c.categoryID !== cat.categoryID)
    });
  }

}
